import { formatCount, formatMoney } from '@utils/currency';

/** Figures the Sales Orders list and the order detail page both print. */

export const formatUnits = (value: number | undefined | null): string =>
    value === undefined || value === null ? '—' : formatCount(value);

/** A rounded money figure in the org's currency, for a value shown beside units. */
export const formatRoundMoney = (value: number): string => formatMoney(value, undefined, { decimals: 0 });
